import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import WithdrawSelect from "../withdraw_select/withdrawSelect";
import CoinSearchbox from "../coinsearchbar";
import Select from 'react-select';
import { AXIOS, api_key } from "../../../config";
import { toast } from "react-toastify";
import { networkInfo ,updateCoinOfNetwrokId} from "../../../store/withdraw";

import { BiTransfer, BiTransferAlt } from "react-icons/bi";
import './withdraw.css'
import { useDispatch, useSelector } from "react-redux";

// import Modal from 'react-modal';

export default ({walletInfo}) => {
  const {  networkId, recipientwalletAddress, coinName ,coinSymbol} = useSelector((state: any) => state.withdraw);

  const [show, setShow] = useState(false);
  const [coinId, setCoinId] = useState('');
  const[nativeBalance,setNativeBalance]= useState('')

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    label:''
  });
  // const [walletInfo, setWalletInfo] = useState({
  //   balance: '',
  //   symbol: ''
  // })
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [error, setError] = useState({
    message: '',
    disable: true
  });
  let userid = sessionStorage.getItem("userid");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [searchResults, setSearchResults] = useState([]);
  const [data, setData] = useState<any>([]);
  const dispatch = useDispatch()

  useEffect(() => {
    (async function () {
      try {
        const response = await AXIOS.post('/depositNetworkList', {
          api_key: api_key,

        });

        console.log('network response', response.data.data)

        const options = response.data.data.map((network: any) => ({
          value: network.symbol,
          label: network.name,
          networkId: network._id
        }));


        setData(options);
      }
      catch (error: any) {
        toast.error(error.message)
      }

    })();

  }, []);

console.log('selected option of network',selectedOption)
  function openModal() {
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  function handleSelectChange(option) {
    setSelectedOption(option);
    closeModal();
  }
  const selectItem = async (item: any) => {

    dispatch(networkInfo(item.networkId))
    setSelectedOption(item)
    closeModal()


  }
  let dummyValue = 5445

  // const handleWithdrawAmount = async (e: any) => {
  //   let value = e.target.value
  //   setWithdrawAmount(value)
  //   if (e.target.value.trim() === '') {
  //     setError({
  //       message: 'Amount is required field',
  //       disable: true
  //     });
  //   } else {

  //     if (value > dummyValue) {
  //       setError({
  //         message: 'Amount must be less then wallet amount',
  //         disable: true
  //       });
  //     }
  //     else {

  //       setError({
  //         message: '',
  //         disable: false
  //       });
  //     }
  //   }
  // }
  
  const getCoinofNetwork=async()=>{
   let response=await AXIOS
      .post('getCoinOfNetwork', {
        api_key: api_key,
        name: coinName,
        symbol: coinSymbol,
        network:selectedOption.label

      })
      dispatch(updateCoinOfNetwrokId(response.data.data._id))
  }
  
  useEffect(() => {
    if (selectedOption.label !='' && coinName !=='') {
      getCoinofNetwork()
    }

  }, [selectedOption,coinName]);
  const getNativeCoinBalance=async () => {
    AXIOS
      .post('getNativeBalance', {
        api_key: api_key,
        user_id:userid
       

      }).then((response) => {setNativeBalance(response.data.data) })
  }
  useEffect(()=>{

    getNativeCoinBalance()
  },[])
  console.log('native balnace',nativeBalance)
  return (
    <>
      <div>
        <Select

          onMenuOpen={openModal}
          value={selectedOption}
          isSearchable={false}
        />

      </div>
    
        <div className="below_drop_wd d-flex justify-content-between mt-5">
          <div className="left_below_drop">
            <div>
              <span>{walletInfo.symbol} Balance</span>
              <p>{walletInfo.balance} {walletInfo.symbol}</p>
            </div>
            
          </div>
          {/* Right side */}
          <div>
              <span>Network fee</span>
              <p>0.001  </p>
            </div>
          <div className="left_below_drop">
            <div>
              <span>Minimum withdrawl</span>
              <p>0.0000078 </p>
            </div>
            {/* <div>
              <span>24h remaining limit</span>
              <p>8,000,000.00 BUSD/8,000,000.00 BUSD</p>
            </div> */}
          </div>
        </div>
    
      {/* {
        selectedOption != null && <div className="withdraw-amount mt-3"> */}


          {/* <div className="mb-2 ms-1 d-flex justify-content-between ">
            <span>Amount</span>
            <div className='d-flex gap-4'>
              <span>8,000,000.00 BUSD/8,000,000.00 BUSD</span>
              <span>Daily remaining limit</span>
            </div>
          </div>
          <div className="input-wrapper">
            <input
              className="search_input"
              type="text"
              placeholder="Enter Amount"
              value={withdrawAmount}
              onChange={(e) => handleWithdrawAmount(e)}
            />
            <div className='d-flex gap-2'>
              <Button variant='muted m-0 p-0' className='srh_btn'>MAX</Button>
              <span className="wd_sp">|</span>
              <span className="wd_sp">BTC</span>
            </div>
          </div>
          {
            error.message &&
            <div className="text-danger">
              {error.message}
            </div>
          } */}
          {/* Radio Section */}
          {/* <div className="radio_sec mt-5 mb-5 d-flex justify-content-between">
            <Form>
              <Form.Check type='radio' name='withdraw_radio' className='wth_chk' label='Spot Wallet' />
              <Form.Check type='radio' name='withdraw_radio' label='Funding Wallet' />
            </Form>
            <div>
              <p className='m-0'>0 BTC</p>
              <p className='m-0'>0 BTC</p>
            </div>
            <div>
              <i> <BiTransfer /> </i>
              <span>Transffer</span>
            </div>
          </div>
          <div className="network_fee">
            <div className="mb-3">
              <h5>Network Fee</h5>
            </div>
            <span>0.001 BNB</span>
          </div> */}
          {/* Received Amounts */}
          {/* <div className="receive_amounts d-flex justify-content-between mt-5 mb-5">
            <div>
              <h3>{nativeBalance} BTC</h3>
              <span className="text-muted"> <i> <BiTransferAlt /> </i> Change Withdrawl amount to received amount </span>
            </div>
            <div>
              <Button className='rc_amnt_btn' disabled={error.disable} onClick={withdraw}>Withdraw</Button>
            </div>
          </div>
        </div>
      } */}
      <Modal show={isModalOpen} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Network</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="coin_list"
            style={{
              maxHeight: "300px",
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <p>
              Please ensure your receiving platform supports the token and
              network you are withdrawing. If you are unsure, kindly check
              with the receiving platform first.
            </p>
            {data.map((item: any, index: any) => {
              return (
                <>
                  <div className="bsc_coin d-flex justify-content-between" key={index} style={{ cursor: 'pointer' }} onClick={() => { selectItem(item) }}>
                    <div>
                      <h6>{item.value}</h6>
                      <span>{item.label}</span>
                    </div>
                    <div className="d-flex flex-column">
                      <span>Arrival Time ≈ 0 mins</span>
                      <span>fee 0.0000039 BTC (≈ $0.118794) </span>
                    </div>
                  </div>
                  <hr /></>
              )
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <a href="http://" target="_blank" rel="noopener noreferrer">
              {" "}
              Fee Rules{" "}
            </a>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

